import React, { PureComponent } from 'react';
import KeyUtils from '../../../common/util/KeyUtils';
import { Flex } from '../../common/Flex';
import DeltaRegulationTable, {
    DeltaRegulationColumn,
    StandardDeltaRegulationColumn,
} from '../../table/DeltaRegulationTable';
import { DeltaAtfcmSituationRegulationDto } from '../../../model/CORE';

const DELTA_REGULATION_LIST_COLUMNS: DeltaRegulationColumn[] = [
    StandardDeltaRegulationColumn.ID,
    StandardDeltaRegulationColumn.IMPACTED_FLIGHTS_BEFORE,
    StandardDeltaRegulationColumn.IMPACTED_FLIGHTS_AFTER,
    StandardDeltaRegulationColumn.IMPACTED_FLIGHTS_DELTA,
    StandardDeltaRegulationColumn.DELAY_BEFORE,
    StandardDeltaRegulationColumn.DELAY_AFTER,
    StandardDeltaRegulationColumn.DELAY_DELTA,
];

interface DeltaRegulationsPanelProps {
    deltaRegulations: Array<DeltaAtfcmSituationRegulationDto>;
}

export class DeltaRegulationsPanel extends PureComponent<DeltaRegulationsPanelProps> {
    render() {
        return (
            <Flex direction="vertical">
                <Flex size="2em" style={{ fontSize: '1.5em', lineHeight: '1.5em', fontWeight: 500 }}>
                    IMPACT ON OTHER MEASURES
                </Flex>
                <Flex>
                    <DeltaRegulationTable
                        data={this.props?.deltaRegulations}
                        columns={DELTA_REGULATION_LIST_COLUMNS}
                        keyProvider={KeyUtils.DELTA_REGULATION_KEY_PROVIDER}
                        columnResizeDisabled={true}
                        noDataMessage={'No measures'}
                    />
                </Flex>
            </Flex>
        );
    }
}
